/* tslint:disable */
/* eslint-disable */
/**
 * dynamic-pricing-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SeasonBatchSaveRequest } from '../models';
// @ts-ignore
import type { SeasonBatchSaveResult } from '../models';
/**
 * SeasonBatchApi - axios parameter creator
 * @export
 */
export const SeasonBatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [courseId] 
         * @param {SeasonBatchSaveRequest} [seasonBatchSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonBatchSavePut: async (courseId?: number, seasonBatchSaveRequest?: SeasonBatchSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Season/BatchSave`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seasonBatchSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeasonBatchApi - functional programming interface
 * @export
 */
export const SeasonBatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeasonBatchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [courseId] 
         * @param {SeasonBatchSaveRequest} [seasonBatchSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seasonBatchSavePut(courseId?: number, seasonBatchSaveRequest?: SeasonBatchSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeasonBatchSaveResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seasonBatchSavePut(courseId, seasonBatchSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonBatchApi.seasonBatchSavePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SeasonBatchApi - factory interface
 * @export
 */
export const SeasonBatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeasonBatchApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [courseId] 
         * @param {SeasonBatchSaveRequest} [seasonBatchSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonBatchSavePut(courseId?: number, seasonBatchSaveRequest?: SeasonBatchSaveRequest, options?: any): AxiosPromise<Array<SeasonBatchSaveResult>> {
            return localVarFp.seasonBatchSavePut(courseId, seasonBatchSaveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeasonBatchApi - object-oriented interface
 * @export
 * @class SeasonBatchApi
 * @extends {BaseAPI}
 */
export class SeasonBatchApi extends BaseAPI {
    /**
     * 
     * @param {number} [courseId] 
     * @param {SeasonBatchSaveRequest} [seasonBatchSaveRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonBatchApi
     */
    public seasonBatchSavePut(courseId?: number, seasonBatchSaveRequest?: SeasonBatchSaveRequest, options?: RawAxiosRequestConfig) {
        return SeasonBatchApiFp(this.configuration).seasonBatchSavePut(courseId, seasonBatchSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

